import { render, staticRenderFns } from "./SellPlanGoodsList.vue?vue&type=template&id=65127a15&scoped=true&"
import script from "./SellPlanGoodsList.vue?vue&type=script&lang=js&"
export * from "./SellPlanGoodsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65127a15",
  null
  
)

export default component.exports